import { render, staticRenderFns } from "./ImagePost.vue?vue&type=template&id=2e6b1018&scoped=true"
import script from "./ImagePost.vue?vue&type=script&lang=js"
export * from "./ImagePost.vue?vue&type=script&lang=js"
import style0 from "./ImagePost.vue?vue&type=style&index=0&id=2e6b1018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b1018",
  null
  
)

export default component.exports